import V from 'voUtils/V.js';

export default {
	voVueComponent: 'voffice-accordion',

	template: `
        <div class="faq-accordion">
            <slot></slot>
        </div>
    `,

	mounted() {
		const items = this.$el.querySelectorAll('.faq-item');

		items.forEach((item, index) => {
			const question = item.querySelector('.faq-question');
			const answer = item.querySelector('.faq-answer');

			if (!question || !answer) {
				return;
			}

			// Antwort zunächst schließen
			answer.hidden = true;

			// Button erzeugen
			const button = document.createElement('button');

			button.type = 'button';
			button.className = 'faq-question-button';
			button.setAttribute('aria-expanded', 'false');
			button.setAttribute('aria-controls', 'faq-answer-' + index);

			// Inhalt der Frage übernehmen
			button.innerHTML = question.innerHTML;

			// ID für die Antwort
			answer.id = 'faq-answer-' + index;

			// Chevron
			const icon = document.createElement('i');

			icon.className =
				'fa-sharp fa-light fa-chevron-down faq-chevron';
			icon.setAttribute('aria-hidden', 'true');

			button.appendChild(icon);

			// Frage durch Button ersetzen
			question.replaceWith(button);

			// Klick
			button.addEventListener('click', () => {
				const isOpen = button.getAttribute('aria-expanded') === 'true';

				button.setAttribute(
					'aria-expanded',
					isOpen ? 'false' : 'true'
				);

				answer.hidden = isOpen;

				icon.classList.toggle('open', !isOpen);
			});
		});
	}
};